import { NetworkApi } from 'network';
import {
	AccessContent,
	AccessDto,
	AccessFilters,
	AccessLimitDto,
	AccessListContent,
	AccessListDetail,
	AccessMeContent,
} from 'types/Access';
import { List } from 'types/List';
import {
	PermissionAuditContent,
	PermissionAuditFilters,
} from 'types/PermissionAudit';

export class AccessService extends NetworkApi {
	public static getAccess(userId: string, filters?: AccessFilters) {
		return this.get<List<AccessContent>, AccessFilters>(
			`/users/${userId}/access`,
			filters,
		);
	}

	public static getAccessList(filters?: AccessFilters) {
		return this.get<List<AccessListContent>, AccessFilters>(
			`/users/access`,
			filters,
		);
	}

	public static getPermissionAudits(filters?: PermissionAuditFilters) {
		return this.get<List<PermissionAuditContent>, PermissionAuditFilters>(
			`/users/access/permission-audits`,
			filters,
		);
	}

	public static getMyAccess(filters?: AccessFilters) {
		return this.get<List<AccessMeContent>, AccessFilters>(
			`/users/me/access`,
			filters,
		);
	}

	public static getAccessDetails() {
		return this.get<AccessListDetail[]>(`/users/me/access/details`);
	}

	public static createAccess(userId: string, accessDto: AccessDto) {
		return this.put<void, AccessDto, void>(
			`/users/${userId}/access`,
			accessDto,
		);
	}

	public static updateAccessPermissions(
		userId: string,
		accessDto: AccessDto,
	) {
		return this.put<void, AccessDto, void>(
			`/users/${userId}/access/permissions`,
			accessDto,
		);
	}

	public static updateApprovalLimit(
		userId: string,
		accessDto: AccessLimitDto,
		mfaToken: string,
	) {
		const headers = {
			'x-mfa-code': mfaToken,
		};

		return this.put<void, AccessLimitDto, { [key: string]: string }>(
			`/users/${userId}/access/approval-limit`,
			accessDto,
			headers,
		);
	}

	public static async deleteAccess(userId: string, accessId: string) {
		return this.delete<void>(`/users/${userId}/access/${accessId}`);
	}

	public static async deleteMultiplesAccess(
		userId: string,
		accessIds: string[],
	) {
		return Promise.all(
			accessIds.map(accessId => this.deleteAccess(userId, accessId)),
		);
	}
}
